import { interactiveServiceFetch } from '../services/interactiveServiceFetch';

const MONITORS_BASE = 'interactive-service/monitors';

export class MonitorApiError extends Error {
    constructor(status, detail) {
        super(`Monitor API error ${status}: ${detail ?? 'unknown'}`);
        this.name = 'MonitorApiError';
        this.status = status;
        this.detail = detail;
    }
}

const extractDetail = body => {
    const detail = body?.detail;
    if (Array.isArray(detail)) return detail[0]?.msg ?? null;
    return typeof detail === 'string' ? detail : null;
};

const request = async (url, options) => {
    const response = await interactiveServiceFetch(url, options);
    if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new MonitorApiError(response.status, extractDetail(body));
    }
    if (response.status === 204) return null;
    return response.json();
};

const jsonOptions = (method, body) => ({
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
});

export const listMonitors = (options = undefined) => request(MONITORS_BASE, options);

export const createMonitor = (userQuery, schedule, title) =>
    request(MONITORS_BASE, jsonOptions('POST', { user_query: userQuery, schedule, title }));

export const suggestMonitorTitle = userQuery =>
    request(`${MONITORS_BASE}/suggest-title`, jsonOptions('POST', { user_query: userQuery }));

export const patchMonitor = (monitorId, fields) =>
    request(`${MONITORS_BASE}/${monitorId}`, jsonOptions('PATCH', fields));

export const recheckMonitor = monitorId => request(`${MONITORS_BASE}/${monitorId}/recheck`, { method: 'POST' });

export const recheckAll = () => request(`${MONITORS_BASE}/recheck-all`, { method: 'POST' });

export const restoreDefaultMonitors = () => request(`${MONITORS_BASE}/restore-defaults`, { method: 'POST' });

export const deleteMonitor = monitorId => request(`${MONITORS_BASE}/${monitorId}`, { method: 'DELETE' });

export const disconnectMonitorSlack = monitorId => request(`${MONITORS_BASE}/${monitorId}/slack`, { method: 'DELETE' });
